import type { CreateFunnelModalProps } from "../AppModalTypes";

import * as React from "react";

import { useModal } from "@editor/hooks/useModal";
import { trpc, trpcUtils } from "@editor/utils/trpc";

import { errorToast } from "@replo/design-system/components/alert/Toast";
import Button from "@replo/design-system/components/button/Button";
import { Modal } from "@replo/design-system/components/modal/Modal";
import { useNavigate } from "react-router-dom";

import Input from "../common/designSystem/Input";

export const CreateFunnelModal: React.FC<CreateFunnelModalProps> = ({
  projectId,
  funnelTemplateId,
}) => {
  const [name, setName] = React.useState<string>("");
  const { closeModal } = useModal();
  const navigate = useNavigate();

  const {
    mutateAsync: createFunnelFromTemplate,
    isPending: createFunnelFromTemplateLoading,
  } = trpc.funnel.createFromTemplate.useMutation();

  const { mutateAsync: createFunnel, isPending: createFunnelLoading } =
    trpc.funnel.create.useMutation();

  const handleCreateFunnel = async () => {
    try {
      let funnelId: string;
      if (funnelTemplateId) {
        const data = await createFunnelFromTemplate({
          projectId: projectId ?? "",
          funnelTemplateId,
          name,
        });
        funnelId = data.funnelId;
      } else {
        const data = await createFunnel({
          projectId: projectId ?? "",
          name,
        });
        funnelId = data.id;
      }

      void trpcUtils.file.list.invalidate({ projectId: projectId ?? "" });
      void trpcUtils.funnel.list.invalidate({ projectId: projectId ?? "" });
      void trpcUtils.funnel.list.invalidate({ projectId: projectId ?? "" });

      navigate(`/shops/${projectId}/funnels/${funnelId}`);
    } catch {
      errorToast("Error creating funnel", "Please try again");
    }
  };

  return (
    <Modal
      title={
        funnelTemplateId ? "Create Funnel From Template" : "Create New Funnel"
      }
      isOpen={true}
      onOpenChange={(open) => {
        if (!open) {
          closeModal({ type: "createFunnelModal" });
        }
      }}
      size="base"
      footer={
        <Button
          variant="primary"
          size="base"
          onClick={() => {
            void handleCreateFunnel();
          }}
          isLoading={createFunnelFromTemplateLoading || createFunnelLoading}
          disabled={createFunnelFromTemplateLoading || createFunnelLoading}
        >
          Create
        </Button>
      }
    >
      <div className="flex w-full flex-col gap-5">
        <div className="flex flex-col gap-2">
          <div className="text-default text-base font-medium">Funnel Name</div>
          <Input
            size="base"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
      </div>
    </Modal>
  );
};
